<div class="wrapper">
    <!-- Sidebar Holder -->
    <nav id="sidebar" class="shadow-lg rounded-2xl m-2 flex flex-column" #sidebar [ngClass]="{'active':toggle}">
        <div class="sidebar-header">
            <img src="/assets/images/kline_logo.svg" align="left">
        </div>
        <dx-tree-view
                [items]="menuItems"
                displayExpr="text"
                [selectByClick]="true"
                [expandAllEnabled]="true"
                [selectNodesRecursive]="false"
                disabledExpr="disabled"
                (onItemClick)="onItemClick($event)"
                class="custom-tree-view"
        ></dx-tree-view>
    </nav>

    <!-- Page Content Holder -->
    <div id="content" #content [ngClass]="{'active':toggle}">

        <nav class="navbar navbar-default shadow-lg rounded-2xl">
            <div class="container-fluid">
                <div class="navbar-header">
                    <button type="button" id="sidebarCollapse" class="btn btn-info navbar-btn" (click)="toggle=!toggle">
                        <i class="fa fa-bars" aria-hidden="true"></i>
                        <span>Toggle Menu</span>
                    </button>
                </div>
                <button type="button" id="logOut" class="btn navbar-btn btn-danger" (click)="logout()" style="float: right">
                    <i class="fa fa-sign-out" aria-hidden="true"></i>
                    <span>Logout</span>
                </button>
            </div>
        </nav>
        <router-outlet></router-outlet>
    </div>
</div>
